var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalLayoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 18.5L18.75 9.23535C18.7499 8.642 18.5155 8.07267 18.0977 7.65137L14.3906 3.91504C13.9682 3.48931 13.3927 3.25 12.793 3.25L7.5 3.25C6.25736 3.25 5.25 4.25736 5.25 5.5L5.25 18.5C5.25 19.7426 6.25736 20.75 7.5 20.75L16.5 20.75C17.7426 20.75 18.75 19.7426 18.75 18.5Z",
    fill: "white",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9L14 9C13.4477 9 13 8.55228 13 8L13 3",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalLayoutIcon);
export default __webpack_public_path__ + "static/media/vertical-layout-icon.68ba54a0381b54c892bf8048d1bf1ea3.svg";
export { ForwardRef as ReactComponent };